import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/App.css';
import '../styles/responsive.css';
import SmallFooter from '../components/SmallFooter';
import BrandLink from '../components/BrandLink';
import { LINKS } from '../constants';
import { FAQ_SECTIONS, faqPageJsonLd } from '../data/faqs';

function FaqAnswer({ item }) {
  if (item.q === 'Who makes Barista Bot?') {
    return (
      <p>
        Barista Bot is a product of{' '}
        <BrandLink href={LINKS.espressoPlusMilk}>Espresso + Milk, LLC</BrandLink>
        , alongside{' '}
        <BrandLink href={LINKS.brandMenuOps}>Menu-Ops</BrandLink> and{' '}
        <BrandLink href={LINKS.brandAllCaps}>ALL CAPS.</BrandLink>
      </p>
    );
  }

  if (item.q === 'What is Menu-Ops?') {
    return (
      <p>
        <BrandLink href={LINKS.brandMenuOps}>Menu-Ops</BrandLink> is the menu
        source of truth from{' '}
        <BrandLink href={LINKS.espressoPlusMilk}>Espresso + Milk</BrandLink>.
        When a shop is not on Square, Menu-Ops holds the menu, Stripe takes
        payment, and a HUD runs the ticket.
      </p>
    );
  }

  if (item.q === 'Where are the privacy policy and terms?') {
    return (
      <p>
        This site’s product policy is the{' '}
        <Link to="/privacy-policy">Privacy Policy</Link> and{' '}
        <Link to="/terms-of-use">Terms of Service</Link>. Company-wide legal is
        the{' '}
        <BrandLink href={LINKS.espressoPrivacy}>
          Espresso + Milk Privacy Policy
        </BrandLink>{' '}
        and{' '}
        <BrandLink href={LINKS.espressoTerms}>Espresso + Milk Terms</BrandLink>.
      </p>
    );
  }

  if (item.q === 'Where can I see it in person?') {
    return (
      <p>
        Book a demo at the studio: 219 NW 12th St, Suite 23, Oklahoma City, OK
        73103.{' '}
        <BrandLink href={LINKS.brandAllCaps}>ALL CAPS.</BrandLink> is the
        hospitality shop that puts Barista Bot and Menu-Ops to work in a real
        cup.
      </p>
    );
  }

  if (item.q === 'How do coffee shops get started?') {
    return (
      <p>
        Beta is open for shops on Square POS.{' '}
        <a href="mailto:sam@beginthework.com">Email Sam</a> or{' '}
        <a
          href="https://calendar.app.google/kE1Qe9Ttqn9UKL8SA"
          target="_blank"
          rel="noopener noreferrer"
        >
          book a demo in Oklahoma City
        </a>
        . We walk through menu import, the ordering flow, and emoji shortcuts.
      </p>
    );
  }

  if (item.q === 'How do I stop texts?') {
    return (
      <p>
        Reply STOP to opt out of non-essential messages. Reply HELP for support,
        or email{' '}
        <a href="mailto:hi@baristabot.app">hi@baristabot.app</a>. Message and
        data rates may apply.
      </p>
    );
  }

  return <p>{item.a}</p>;
}

function Faq() {
  return (
    <main>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqPageJsonLd()) }}
      />
      <section className="legal-page faq-page">
        <div className="legal-container">
          <h1>FAQs</h1>
          <p className="legal-effective">
            Text ordering for coffee shops. A product of{' '}
            <BrandLink href={LINKS.espressoPlusMilk}>
              Espresso + Milk, LLC
            </BrandLink>
            .
          </p>

          {FAQ_SECTIONS.map((section) => (
            <section key={section.id} aria-labelledby={`faq-${section.id}`}>
              <h2 id={`faq-${section.id}`}>{section.title}</h2>
              {section.items.map((item) => (
                <div key={item.q} className="faq-item">
                  <h3>{item.q}</h3>
                  <FaqAnswer item={item} />
                </div>
              ))}
            </section>
          ))}
        </div>
      </section>
      <SmallFooter />
    </main>
  );
}

export default Faq;
